export default "__VITE_ASSET__5ead0918__"